/*
 * Created on Wed Aug 09 2023
 *
 * Project: BKN_FRONT
 * Copyright (c) 2023 Nttdata
 */
import React from 'react';
import { IDLE_URL } from "../../constants/URL";

//COMPONENTS MUI
import ModalUnstyled from '@mui/base/ModalUnstyled';
import { Button } from "@mui/material";
import { styled, Box } from '@mui/system';

import PropTypes from 'prop-types';
import clsx from 'clsx';

const BackdropUnstyled = React.forwardRef((props, ref) => {
    const { open, className, ...other } = props;
    return (
      <div
        className={clsx({ 'MuiBackdrop-open': open }, className)}
        ref={ref}
        {...other}
      />
    );
  });

  BackdropUnstyled.propTypes = {
    className: PropTypes.string.isRequired,
    open: PropTypes.bool,
  };

  const Modal = styled(ModalUnstyled)`
  position: fixed;
  z-index: 1300;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Backdrop = styled(BackdropUnstyled)`
  z-index: -1;
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const style = (theme) => ({
    width: 400,
    bgcolor: theme.palette.mode === 'dark' ? '#0A1929' : 'white',
    border: '2px solid currentColor',
    padding: '16px 32px 24px 32px',
  });

export const IdleTimeOutModal = ({showModal, handleContinue, handleLogout, remainingTime}) => {

    return (
        /*<Modal
            hideBackdrop
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
            open={showModal}
            onClose={handleContinue}>
            <h2 id="unstyled-modal-title">Text in a modal</h2>
            <Button onClick={handleLogout}>
                Logout
            </Button>
            <Button onClick={handleContinue}>
                Continue Session
            </Button>
        </Modal>*/
        <Modal
        aria-labelledby="unstyled-modal-title"
        aria-describedby="unstyled-modal-description"
        open={showModal}
        onClose={handleContinue}
        slots={{ backdrop: Backdrop }}
      >
        <Box sx={style}>
            <h2>Necessites més temps?</h2>
            <strong>La sessió està a punt de caducar. És finalitzarà la sessió automàticament</strong>
            <br></br>
            {/*<div>Per seguir utilitzant l'aplicació sel·leccioni continuar sessió</div>*/}
            <Button onClick={handleContinue}>
                Continuar sessió
            </Button>
            <Button onClick={() => { handleLogout(); window.location.replace(IDLE_URL);}}>
                Abandonar sessió
            </Button>
        </Box>
      </Modal>
    )
}